import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import Keyboard from "simple-keyboard";
import { Servicio } from '../servicio/servicio';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Documento } from '../clase/documento';
import { BehaviorSubject, Observable } from 'rxjs';
import { Persona } from '../modelo/persona';
import { UntypedFormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AlertService, AuthenticationService } from '../servicio';
import { AuthGuard } from '../guardia/auth.guard';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SwUpdate } from '@angular/service-worker';

import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-loginvoto',
  templateUrl: './loginvoto.component.html',
  styleUrls: ['./loginvoto.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginvotoComponent implements OnInit, OnDestroy {
  public executeImportantAction(): void {

  }

  isShift = false;
  seperator = "/";

  IsNumeric(e) {
    const keyCode = e.keyCode;
    const input = e.target;
    let valor = input.value.replace(/\D/g, ''); // Eliminar caracteres no numéricos
    console.log(valor);
    if (valor.length > 0) {
      let dia = parseInt(valor.substring(0, 2));
      let mes = parseInt(valor.substring(2, 4));
      let anio = parseInt(valor.substring(4, 8));

      // Validar que los valores son numéricos y están dentro de los rangos adecuados
      if (!isNaN(dia) && dia >= 1 && dia <= 31 && !isNaN(mes) && mes >= 1 && mes <= 12 && !isNaN(anio)) {
        // Crear la fecha en el formato deseado
        let fechaFormateada = ('0' + dia).slice(-2) + '/' + ('0' + mes).slice(-2) + '/' + anio;

        // Asignar el valor formateado a la propiedad fecha
        input.value = fechaFormateada;
      }
    }
  }
  /*IsNumeric(e) {
   const keyCode = e.keyCode;
   const input = e.target;

   if (keyCode === 16) {
       this.isShift = true;
   }

   // Allow only Numeric Keys, Backspace, and navigation keys
   const isValidKey = (keyCode >= 48 && keyCode <= 57) || keyCode === 8 || (keyCode >= 37 && keyCode <= 39) || (keyCode >= 96 && keyCode <= 105);

   if (isValidKey && !this.isShift) {
       const hasReachedMaxLength = input.value.length === 2 || input.value.length === 5;

       if (hasReachedMaxLength && keyCode !== 8) {
           // Check if the last entered character is not the separator
           if (input.value.charAt(input.value.length - 1) !== this.seperator) {
               input.value += this.seperator;
           }
       }

       return true;
   } else {
       return false;
   }
};*/

  ValidateDateFormat(e) {
    let keyCode = e.keyCode;
    let input = e.target;
    var dateString = input.value;

    if (keyCode == 16) {
      this.isShift = false;
    }
    var regex = /(((0|1)[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19|20)\d\d))$/;

    //Check whether valid dd/MM/yyyy Date Format.
    if (regex.test(dateString) || dateString.length == 0) {
      //  ShowHideError(input, "none");
    } else {
      //ShowHideError(input, "block");
    }
  };



  hide = true;
  valor_clave = "";

  @ViewChild('claves', { static: false, read: ElementRef }) claves: ElementRef;

  @ViewChild('documento', { static: false, read: ElementRef }) documento_element: ElementRef;
  iniciar_votacion() {
    this.route.queryParamMap.subscribe((queryParams) => {
      //   const lastVisitedId = queryParams.get('lastVisited');
      console.log(queryParams);
      const token = queryParams.get('token');
      if (token != null) {
        //alert(token);



        var request = {};
        request["token"] = token;

        this.authenticationService.iniciar_sesion_voto(request, this.checkoutForm);





      }

    });
  }

  iddispositivo = "";
  generar_uud() {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
      deviceId = this.generateUUIDV4()
      localStorage.setItem('deviceId', deviceId)
    }
    this.iddispositivo = deviceId;
    console.log(this.iddispositivo);
    return deviceId

  }
  generateUUIDV4(): string {
    // http://www.ietf.org/rfc/rfc4122.txt
    const s = []
    const hexDigits = '0123456789abcdef'
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    // eslint-disable-next-line no-bitwise
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'

    const uuid = s.join('')
    return uuid
  }

  datos_navedor = "";
  async extraccion_datos() {



    let aKeys = ["MSIE", "Firefox", "Safari", "Chrome", "Opera"],
      sUsrAg = navigator.userAgent, nIdx = aKeys.length - 1;

    var Name = "Not known";
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) Name = "Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) Name = "Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) Name = "Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) Name = "Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) Name = "Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) Name = "Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac") != -1) Name = "Mac/iOS";
    if (window.navigator.userAgent.indexOf("X11") != -1) Name = "UNIX";
    if (window.navigator.userAgent.indexOf("Linux") != -1) Name = "Linux";

    for (nIdx; nIdx > -1 && sUsrAg.indexOf(aKeys[nIdx]) === -1; nIdx--);



    let tipo = 1;
    const getCoords = async () => {

      let pos: any = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      }).catch((error) => {
        console.log(error);
        tipo = 0;
      });
      if (tipo == 1) {
        return {
          long: pos.coords.longitude,
          lat: pos.coords.latitude,
          tipo_ubicacion: 1
        };
      } else {
        return {
          long: 0,
          lat: 0,
          tipo_ubicacion: 0
        };

      }

    };

    const coords = await getCoords();
    this.datos_navedor = Name + "-" + aKeys[nIdx] + "/" + coords.tipo_ubicacion.toString() + "/" + coords.lat.toString() + "/" + coords.long.toString();
    console.log(this.datos_navedor);
  }



  FULL_DASH_ARRAY = 283;
  WARNING_THRESHOLD = 60;
  ALERT_THRESHOLD = 20;
  isHidden = true;

  COLOR_CODES = {
    info: {
      color: "green"
    },
    warning: {
      color: "orange",
      threshold: this.WARNING_THRESHOLD
    },
    alert: {
      color: "red",
      threshold: this.ALERT_THRESHOLD
    }
  };


  TIME_LIMIT = 120;
  timePassed = 0;
  timeLeft = this.TIME_LIMIT;
  timerInterval = null;
  remainingPathColor = this.COLOR_CODES.info.color;

  temp_hora = this.TIME_LIMIT;






  onTimesUp() {
    clearInterval(this.timerInterval);
  }

  startTimer() {
    let _this = this;
    this.timerInterval = setInterval(() => {
      this.timePassed = this.timePassed += 1;
      this.timeLeft = this.TIME_LIMIT - this.timePassed;

      this.setCircleDasharray();
      this.setRemainingPathColor(this.timeLeft);

      if (this.timeLeft === 0) {
        this.onTimesUp();
        _this.isHidden = false;
      }
    }, 1000);
  }








  setRemainingPathColor(timeLeft) {
    const { alert, warning, info } = this.COLOR_CODES;
    if (timeLeft <= alert.threshold) {

      this.remainingPathColor = alert.color;
      /* document
         .getElementById("base-timer-path-remaining")
         .classList.remove(warning.color);
       document
         .getElementById("base-timer-path-remaining")
         .classList.add(alert.color);*/
    } else if (timeLeft <= warning.threshold) {
      /*  document
          .getElementById("base-timer-path-remaining")
          .classList.remove(info.color);
        document
          .getElementById("base-timer-path-remaining")
          .classList.add(warning.color);*/

      this.remainingPathColor = warning.color;
    }
  }

  formatTime(time) {
    const minutes = Math.floor(time / 60);
    let seconds = time % 60;

    if (seconds < 10) {
      //seconds = `0${seconds}`;
    }

    return `${minutes}:${seconds}`;
  }

  calculateTimeFraction() {
    const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
    return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
  }

  setCircleDasharray() {
    const circleDasharray = `${(
      this.calculateTimeFraction() * this.FULL_DASH_ARRAY
    ).toFixed(0)} 283`;

    document.getElementById("base-timer-path-remaining").setAttribute("stroke-dasharray", circleDasharray);
  }

  recargar() {

    location.reload();
  }


  estado_teclado = false;
  lat;
  lng;
  zoom;

  estado_tarjeta = true;
  getUserLocation() {
    // get Users current position

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 16;
        // console.log("position", position)
      });
    } else {
      console.log("User not allowed")
    }
  }
  verificar(value) {
    var valor1: String;
    valor1 = value.target.value;
    if (valor1.length == this.tan) {
      this.claves.nativeElement.focus();
      var _this = this;
      setTimeout(function () { _this.claves.nativeElement.focus(); }, 5000);
    }
  }
  selected;
  private currentUserSubject: BehaviorSubject<Persona>;
  public currentUser: Observable<Persona>;

  tan = 8;
  crear_variable = {};
  checkoutForm;
  returnUrl: string;
  documentos: Documento[] = [];
  votoCanal;
  votoIpHost;
  zfill(number, width) {
    var numberOutput = Math.abs(number); /* Valor absoluto del número */
    var length = number.toString().length; /* Largo del número */
    var zero = "0"; /* String de cero */
    if (width <= length) {
      if (number < 0) {
        return ("-" + numberOutput.toString());
      } else {
        return numberOutput.toString();
      }
    } else {
      if (number < 0) {
        return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
      } else {
        return ((zero.repeat(width - length)) + numberOutput.toString());
      }
    }
  }

  movil = false;
  constructor(private recaptchaV3Service: ReCaptchaV3Service, private swUpdate: SwUpdate, public comprobar: DeviceDetectorService, private route: ActivatedRoute, private authenticationService: AuthenticationService,
    private alertService: AlertService, private formBuilder: UntypedFormBuilder, private servicio: Servicio, private router: Router, private ngxService: NgxUiLoaderService) {

    //this.executeImportantAction();
    if (this.comprobar.isMobile()) {
      this.movil = true;
    }







    this.checkoutForm = this.formBuilder.group({
      documento: ['01', Validators.required],
      numero_documento: ['', Validators.required],
      // clave: ['', Validators.compose([ Validators.required, Validators.minLength(6)]) ]
      clave: ['', Validators.compose([Validators.required])]

    });
    this.currentUserSubject = new BehaviorSubject<Persona>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();





    var datos = {};
    let token;
    token = this.token();

    let _this = this;

    datos["id_dispositivo"] = token;
    this.servicio.enviar("api/ws_creartokensimple_time", datos).pipe().subscribe(
      response => {

        // console.log(response["token"]);

        sessionStorage.setItem("token", response["token"]);
        this.iniciar_votacion();
        var datos1 = {};
        _this.servicio.enviar_seguro("api/ws_peclSeltipoidentidad", datos1, response["token"]).pipe().subscribe(
          datos => {
            //console.log(datos["response"]);
            datos["response"].forEach(element => {
              _this.documentos.push(new Documento(element["TipoIdentidadID"], element["NomIdentidad"]));
              _this.selected = '01';
              _this.crear_variable[element["TipoIdentidadID"]] = element["NroCaracter"];
            }
            );
          },
          error => {
          }
        );











      },
      error => {
      }
    );











  }


  token() {
    return this.random() + this.random() + this.random(); // Para hacer el token más largo
  };


  random() {
    return Math.random().toString(36).substr(2); // Eliminar `0.`
  };
  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }
  onchange(e) {
    var data = e.value;
    this.tan = this.crear_variable[data];
    ///  alert(this.tan);

    if (e.value == "16") {
      this.estado_tarjeta = true;
    } else {
      this.estado_tarjeta = false;

    }
    //  console.log(this.tan);
  }
  public get currentUserValue(): Persona {
    return this.currentUserSubject.value;
  }
  onSubmit(customerData) {
    this.recaptchaV3Service.execute('login')
      .subscribe((token) => {
        console.log(token);
        var request = {};
        request["documento"] = customerData["documento"];
        request["numero_documento"] = customerData["numero_documento"].toString();
        // request["clave"]=this.keyboard.getInput();
        request["clave"] = customerData["clave"];
        request["token"] = "";
        request["votoCanal"] = "WEB";
        request["votoIpHost"] = this.votoIpHost;
        request["EquipoID"] = this.iddispositivo;
        request["EquipoDescripcion"] = this.datos_navedor;
        request["token_google"] = token;
        if (this.checkoutForm.dirty && this.checkoutForm.valid) {
          this.authenticationService.iniciar_sesion_voto(request, this.checkoutForm);
          this.valor_clave = '';
        }
      });



  }



  ngOnDestroy() {


    this.onTimesUp();
  }

  ngOnInit() {

    if (this.swUpdate.isEnabled) {

      this.swUpdate.available.subscribe(() => {

        if (confirm("Existe una nueva version por favor actualizar")) {

          window.location.reload();
        }
      });
    }

    this.generar_uud();
    this.extraccion_datos();
    this.getUserLocation();
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/inicio']);
    }
    var _this = this;
    fetch('https://api.ipify.org/?format=json')
      .then(function (response) {
        return response.json();
      })
      .then(function (reponse) {

        _this.votoIpHost = reponse["ip"];
        //  console.log( _this.votoIpHost);
      });





    this.startTimer();




  }
  value = "";
  keyboard: Keyboard;
  primer_ordenamiento = "";
  segundo_ordenamiento = "";

  cargar() {
    //  alert("hola");
    this.cargar_teclado();
  }
  ngAfterViewInit() {

    /* var a = [1, 2, 3, 4, 5, 6, 7, 8,9,0];
     var b = this.shuffle(a);
     for(var i=0;i<=9;i++){
       if(i!=9){
       this.primer_ordenamiento+=b[i]+" ";
     }else{
       this.primer_ordenamiento+=b[i]+"";
     }
       if(i!=5){
         this.primer_ordenamiento+=b[i]+" ";
       }else{
         this.primer_ordenamiento+=b[i]+"";
       }
     }
     for(var i=6;i<=9;i++){
       if(i!=9){
         this.segundo_ordenamiento+=b[i]+" ";
       }else{
         this.segundo_ordenamiento+=b[i]+"";
       }
     }


     this.keyboard = new Keyboard({
       onChange: input => this.onChange(input),
       onKeyPress: button => this.onKeyPress(button),
       mergeDisplay: true,
       layoutName: "default",
       layout: {
         default: [
           this.primer_ordenamiento,
           "q w e r t y u i o p",
           "a s d f g h j k l",
           "{shift} z x c v b n m {backspace}",

         ],
         shift: [
           this.primer_ordenamiento,
           "Q W E R T Y U I O P",
           "A S D F G H J K L",
           "{shift} Z X C V B N M {backspace}",

         ],
         numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"]
       },
       display: {
         "{numbers}": "123",
         "{ent}": "return",
         "{escape}": "esc ⎋",
         "{tab}": "tab ⇥",
         "{backspace}": "⌫",
         "{capslock}": "caps lock ⇪",
         "{shift}": "⇧",
         "{controlleft}": "ctrl ⌃",
         "{controlright}": "ctrl ⌃",
         "{altleft}": "alt ⌥",
         "{altright}": "alt ⌥",
         "{metaleft}": "cmd ⌘",
         "{metaright}": "cmd ⌘",
         "{abc}": "ABC"
       }
     });

     /*this.keyboard = new Keyboard({
       onChange: input => this.onChange(input),
       onKeyPress: button => this.onKeyPress(button),
       debug: false,
       display : {
         "{bksp}": "⌫",
      } ,
      maxLength: 6,
       layout: {
         default: [ this.primer_ordenamiento,this.segundo_ordenamiento+' {bksp}'],
       },
       theme: "hg-theme-default hg-theme-ios",
     });*/
  }


  cont = 0;
  eliminar_teclado() {
    if (this.cont == 1) {
      this.keyboard.destroy();
    }

    this.estado_teclado = false;
    this.valor_clave = "";
    //document.activeElement.blur();
    //this.checkoutForm.controls['clave'].setValue("");

  }

  cargar_teclado() {
    this.documento_element.nativeElement.blur();
    //alert();
    if (this.estado_teclado == true) {
      return false;
    }
    this.cont = 1;
    var a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
    var b = this.shuffle(a);
    this.primer_ordenamiento = "";
    for (var i = 0; i <= 9; i++) {
      if (i != 9) {
        this.primer_ordenamiento += b[i] + " ";
      } else {
        this.primer_ordenamiento += b[i] + "";
      }
      /* if(i!=5){
         this.primer_ordenamiento+=b[i]+" ";
       }else{
         this.primer_ordenamiento+=b[i]+"";
       }
     }
     for(var i=6;i<=9;i++){
       if(i!=9){
         this.segundo_ordenamiento+=b[i]+" ";
       }else{
         this.segundo_ordenamiento+=b[i]+"";
       }*/
    }


    /*
      this.keyboard = new Keyboard({
        onChange: input => this.onChange(input),
        onKeyPress: button => this.onKeyPress(button),
        mergeDisplay: true,
        layoutName: "default",
        layout: {
          default: [
            this.primer_ordenamiento,
            "q w e r t y u i o p",
            "a s d f g h j k l ñ",
            "{shift} z x c v b n m {backspace}",

          ],
          shift: [
            this.primer_ordenamiento,
            "Q W E R T Y U I O P",
            "A S D F G H J K L Ñ",
            "{shift} Z X C V B N M {backspace}",

          ],
          numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"]
        },
        display: {
          "{numbers}": "123",
          "{ent}": "return",
          "{escape}": "esc ⎋",
          "{tab}": "tab ⇥",
          "{backspace}": "⌫",
          "{capslock}": "caps lock ⇪",
          "{shift}": "⇧",
          "{controlleft}": "ctrl ⌃",
          "{controlright}": "ctrl ⌃",
          "{altleft}": "alt ⌥",
          "{altright}": "alt ⌥",
          "{metaleft}": "cmd ⌘",
          "{metaright}": "cmd ⌘",
          "{abc}": "ABC"
        }
      });*/
    this.estado_teclado = true;
  }

  recuperar() {
    this.router.navigate(['/recuperar']);
  }





  shuffle(arr) {
    var i,
      j,
      temp;
    for (i = arr.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      temp = arr[i];
      arr[i] = arr[j];
      arr[j] = temp;
    }
    return arr;
  };
  onChange = (input: string) => {
    var tam = input.length;
    this.value = "";
    for (var i = 0; i < tam; i++) {
      // this.value += "ಠ";
    }
  };
  onKeyPress = (button: string) => {
    if (button === "{shift}" || button === "{lock}") { this.handleShift(); return false; }
    if (button === "{numbers}" || button === "{abc}") { this.handleNumbers(); return false; }
    // console.log("Button pressed", button);

    if (button == "{backspace}") {
      /* if(this.valor_clave.length!=6){
       this.valor_clave+=button;
     }
     }else{*/
      var texto = this.valor_clave;
      //  console.log(texto);
      texto = texto.substring(0, texto.length - 1);
      this.valor_clave = texto;
    } else {
      this.valor_clave += button;
    }
    // console.log(this.valor_clave);
    var tam = this.valor_clave.length;
    this.value = "";
    for (var i = 0; i < tam; i++) {
      this.value += "ಠ";
    }

    this.checkoutForm.controls['clave'].setValue(this.value);

  };
  onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value);
  };
  handleShift = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };


  handleNumbers = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let numbersToggle = currentLayout !== "numbers" ? "numbers" : "default";

    this.keyboard.setOptions({
      layoutName: numbersToggle
    });
  }












  onInputFocus() { }
  maps() {
    this.router.navigate(['/maps']);
  }
  registrar() {
    this.router.navigate(['/registrar']);
  }
  get passwordCtrl() {
    return this.checkoutForm.get('clave');
  }
}
